import GoogleAuth from "./GoogleAuth";

export default GoogleAuth;